
<div class="flex-box" fillComponentParentView="fillComponentParentView">
  <div class="flex-heading" #headingView>
    <div class="col-xs-12 list-header"><span class="pR10">{{ iframeLink ? '' : 'Loading...' }}</span></div>
  </div>
  <div class="flex-content">
    <iframe class="w-full h-full" *ngIf="iframeLink" [src]="iframeLink" allowtransparency="allowtransparency"></iframe>
  </div>
</div>
